import { render, staticRenderFns } from "./LabelOrderDialog.vue?vue&type=template&id=32440646&scoped=true&"
import script from "./LabelOrderDialog.vue?vue&type=script&lang=js&"
export * from "./LabelOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./LabelOrderDialog.vue?vue&type=style&index=0&id=32440646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32440646",
  null
  
)

export default component.exports